import React from 'react'

const Box = ({ className, children, innerClass }) => {
    if (className === undefined) className = "";
    return (
      <div className={`p-1 p-sm-3 p-xl-4 w-100 ${className}`}>
        <div className={`rounded-4 overflow-hidden w-100 ${innerClass}`}>{children}</div>
      </div>
    );
  };

export default Box